import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { getAppRoles, getOrgUser, setOrgUserRole } from "../../../../userUtils";

const UserProfile = (props: any) => {

    const [user, setUser] = useState<any>(null);
    const [userRoles, setUserRoles] = useState<any>(null);
    const [selectedRoleId, setSelectedRoleId] = useState<any>(null);

    useEffect(() => {
        (async function fetchData() {
            await load();
        })();
    }, [props.userId]); // eslint-disable-line react-hooks/exhaustive-deps

    const load = async () => {
        const resultRoles = await getAppRoles(props.client);
        const resultUser = await getOrgUser(props.client, props.orgId, props.userId);
        
        console.log('GET_APP_ROLES', resultRoles);
        console.log('GET_ORG_USER_WITH_ROLES', resultUser);

        setUserRoles(resultRoles.data.syncarto_app_role);
        setUser(resultUser.data);

        setSelectedRoleId(resultUser.data.syncarto_app_user_by_pk.org_user[0].role.id);
    }

    const handleChange = (e:any) => {
        setSelectedRoleId(e.target.value);
    }

    const updateRole = async (e:any) => {
        let currentOrgUser = user.syncarto_app_user_by_pk.org_user[0];

        let result = await setOrgUserRole(props.client, currentOrgUser.id, props.userId, selectedRoleId, props.orgId);

        console.log("Org User Update > result,", result);
        setTimeout(() => {
            props.shouldRefreshUsers();
        }, 500);  
    }

    if(!user || !userRoles) {
        return (
            <div>loading...</div>
        );
    }
    
    return (
        <>
            <h4>Update User</h4>
            <Form style={{marginTop: "10px", padding:"1em"}}>
                <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                        Name
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control plaintext readOnly value={user.syncarto_app_user_by_pk.name}/>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                        Email
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control plaintext readOnly value={user.syncarto_app_user_by_pk.email}/>
                    </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formRoles">
                    <Form.Label column sm="2">
                        Roles
                    </Form.Label>
                    <Col sm="10">
                        <Form.Control
                            as="select"
                            onChange={handleChange}
                            value={selectedRoleId ? selectedRoleId : undefined}
                        >
                            {
                                userRoles.map((role: any) => {
                                    return (
                                        <option key={role.id} value={role.id}>{role.name}</option>
                                    );
                                })
                            }
                        </Form.Control>      
                    </Col>
                </Form.Group>
                <div style={{paddingTop: "7px"}}>
                    <Button variant="warning" onClick={updateRole}>Update</Button>
                </div>
            </Form>
        </>
    );
}

export default UserProfile;